export const DEVICE_SM = '576px';
export const DEVICE_MD = '820px';
export const DEVICE_LG = '1024px';
export const DEVICE_XL = '1440px';

export const MEDIA_SM = `(max-width: ${DEVICE_SM})`;
export const MEDIA_MD = `(max-width: ${DEVICE_MD})`;
export const MEDIA_LG = `(max-width: ${DEVICE_LG})`;
export const MEDIA_XL = `(max-width: ${DEVICE_XL})`;
